import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import IpiCstService from "./ipiCstService"
import FormList from 'base/FormList'

export default function IpiCstList() {

    const [service] = useState(() => new IpiCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_ipicst',
        dsName: 'descricao_ipicst',
        mainField: { name: 'descricao_ipicst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_ipicst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'codigo_ipicst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_ipicst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_ipicst" sortable header="Código"></Column>
            <Column field="descricao_ipicst" sortable header="Descrição" style={{ whiteSpace: 'normal' }}></Column>
        </FormList >
    )
}
